import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { CORE_CONFIG } from '../../config/core-config';
import { StorageService } from '../../storage/storage.service';

export const tokenRefreshInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const config = inject(CORE_CONFIG);
  const storage = inject(StorageService);

  const persistNewToken = (headers: HttpHeaders | undefined) => {
    const newToken = headers?.get('X-New-Token');
    if (newToken) {
      storage.set(config.tokenKey, newToken);
    }
  };

  return next(request).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        persistNewToken(event.headers);
      }
    }),
    // TEC-371: un API que rote sobre una respuesta de error también manda
    // X-New-Token; si no se guarda, el token viejo muere en ~24 h.
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        persistNewToken(error.headers);
      }
      return throwError(() => error);
    })
  );
};
